import React from 'react'
import Page from 'layout/access-management/page'
import PageTitle from 'layout/page-title'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Table from './Table'
import Filters from './filters'

function Duties() {
  const [params, setParams] = React.useState({
    page: 1,
    perPage: 25,
    process_type_id: '',
    rule_type_id: '',
    department_code: '',
    rule_number: '',
    step_number: '',
    has_pending_workflow: ''
  })

  return (
    <Page title={'Access Management'}>
      <PageTitle />

      <Row>
        <Col sm={12}>
          <Filters params={params} setParams={setParams} />
        </Col>
      </Row>

      <Row>
        <Col sm={12}>
          <Table params={params} setParams={setParams} />
        </Col>
      </Row>
    </Page>
  )
}

export default Duties
